import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      denominationPopin: _vm.mode == "popin"
    }
  }, [_c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field required",
    attrs: {
      label: "Region",
      items: _vm.regions,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue]
    },
    on: {
      change: function change($event) {
        return _vm.getRegionAppellations();
      }
    },
    model: {
      value: _vm.baseModel.region.id,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel.region, "id", $$v);
      },
      expression: "baseModel.region.id"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field required",
    attrs: {
      label: "Appellation",
      items: _vm.appellationsParents,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "appellation",
      "item-value": "id_appellation",
      "hide-details": "auto",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.getAppellationDenominations();
      }
    },
    model: {
      value: _vm.baseModel.id_parent_appellation,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "id_parent_appellation", $$v);
      },
      expression: "baseModel.id_parent_appellation"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Denomination label",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.appellation,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "appellation", $$v);
      },
      expression: "baseModel.appellation"
    }
  }), _vm.existingAppellationDenominations.length > 0 ? _c("div", {
    staticClass: "flex flex-column justify-start items-start mt-default"
  }, [_c("div", {
    staticClass: "flex items-baseline justify-start gap-2"
  }, [_c(VIcon, {
    class: ["fa cursor--pointer", _vm.isShowExisitingAppellationDenominations ? "fa-eye-slash" : "fa-eye"],
    attrs: {
      size: "16"
    },
    on: {
      click: function click($event) {
        return _vm.toggleShowDenominations();
      }
    }
  }), _c("span", {
    staticClass: "text-bold cursor--pointer",
    on: {
      click: function click($event) {
        return _vm.toggleShowDenominations();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.existingAppellationDenominations.length) + " existing denomination(s) for the appellation ")])], 1), _vm.isShowExisitingAppellationDenominations ? _c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.existingAppellationDenominations, function (item) {
    var _vm$manageExistingDen, _vm$manageExistingDen2, _vm$manageExistingDen3;
    return _c("li", {
      key: "existingRegionDenomination-".concat(item.id_appellation),
      staticClass: "text-smaller py-1"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(" " + _vm._s("".concat(item.appellation)) + " ")]), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-edit",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.startEditDenomination(item.id_appellation);
        }
      }
    }), _c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.deleteDenomination(item.id_appellation);
        }
      }
    })], 1)]), ((_vm$manageExistingDen = _vm.manageExistingDenomination.error.delete) === null || _vm$manageExistingDen === void 0 ? void 0 : _vm$manageExistingDen.id_appellation) == item.id_appellation ? [_c("div", [((_vm$manageExistingDen2 = _vm.manageExistingDenomination.error.delete) === null || _vm$manageExistingDen2 === void 0 ? void 0 : _vm$manageExistingDen2.code) === "wine_attached" ? [_c("div", {
      staticClass: "flex items-baseline justify-start gap-2"
    }, [_c(VIcon, {
      class: ["fa cursor--pointer", _vm.manageExistingDenomination.error.delete.isDetailsShown ? "fa-eye-slash" : "fa-eye"],
      attrs: {
        size: "16"
      },
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteWinesAttached();
        }
      }
    }), _c("span", {
      staticClass: "errorLabel cursor--pointer",
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteWinesAttached();
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.manageExistingDenomination.error.delete.data.length) + " wine(s) are attached to this denomination. It can't be deleted ")])], 1), _vm.manageExistingDenomination.error.delete.isDetailsShown ? _c("ul", {
      staticClass: "rm-margin pl-5"
    }, _vm._l(_vm.manageExistingDenomination.error.delete.data, function (wine) {
      return _c("li", {
        key: "existingAppellation-".concat(item.id_appellation, "-error-appellation-attached-").concat(wine.id_wine),
        staticClass: "text-smaller"
      }, [_vm._v(" " + _vm._s("".concat(wine.accountancy_code, " : ").concat(_vm.formatWineNaming(wine.naming_data))) + " ")]);
    }), 0) : _vm._e()] : _vm._e()], 2)] : _vm._e(), ((_vm$manageExistingDen3 = _vm.manageExistingDenomination.model) === null || _vm$manageExistingDen3 === void 0 ? void 0 : _vm$manageExistingDen3.id_appellation) === item.id_appellation ? _c("div", {
      staticClass: "mt-2 pb-5 px-5 mb-3",
      staticStyle: {
        "border-left": "1px #dadada solid",
        "border-bottom": "1px #dadada solid"
      }
    }, [_c(VForm, {
      staticClass: "dfwa-form",
      model: {
        value: _vm.manageExistingDenomination.form.valid,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingDenomination.form, "valid", $$v);
        },
        expression: "manageExistingDenomination.form.valid"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        label: "Denomination label",
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.manageExistingDenomination.model.appellation,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingDenomination.model, "appellation", $$v);
        },
        expression: "manageExistingDenomination.model.appellation"
      }
    })], 1), _c("div", {
      staticClass: "flex items-center mt-small"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          return _vm.closeEditExistingDenomination();
        }
      }
    }, [_vm._v(" Cancel ")]), _c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      attrs: {
        rounded: true,
        disabled: !_vm.manageExistingDenomination.form.valid
      },
      on: {
        click: function click($event) {
          return _vm.saveEditExistingDenomination();
        }
      }
    }, [_vm._v(" Save ")])], 1)], 1) : _vm._e()], 2);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "tip mt-small-2"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" Please be care to not create duplicate of existing denomination. ")])]) : _vm._e()], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Close")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.form.valid
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Save" : "Create") + " ")])], 1)], 1), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };